import React, { useState } from "react";
import localization from "assets/localization/localization";
import ConstantInput from "components/sales/Input/constantInput/constantInput";

const HsnFilter = ({
  showFilter,
  applyFilter,
  setSelectedHsn,
  setSelectedGst,
}) => {

  const storageKey = "hsn_filter";

  const savedFilter = JSON.parse(window.localStorage.getItem(storageKey) || "{}");

  const [filterFieldsData, setFilterFieldsData] = useState({
    hsn_code: savedFilter?.hsn_code || "",
    gst_code: savedFilter?.gst_code || "",
  });

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        window.localStorage.setItem(storageKey, JSON.stringify(filterFieldsData));
        applyFilter(filterFieldsData);
      }}
    >
      <ConstantInput
        label="HSN"
        type="number"
        isStarRequired={false}
        value={filterFieldsData.hsn_code}
        handleChange={(val) => {
          setFilterFieldsData({
            ...filterFieldsData,
            hsn_code: val,
          });
          setSelectedHsn(val);
        }}
      />

      <ConstantInput
        label="GST Code"
        type="text"
        isStarRequired={false}
        value={filterFieldsData.gst_code}
        handleChange={(val) => {
          setFilterFieldsData({
            ...filterFieldsData,
            gst_code: val,
          });
          setSelectedGst(val);
        }}
      />

      <div className="btn-wrapper">
        <button disabled={false} type="submit" className="btn btn-primary">
          {localization.applyFilter}
          <img src="../images/arrow-right.png" alt="" />
        </button>

        <br />
        <br />

        <button
          onClick={() => {
            setSelectedHsn("");
            setSelectedGst("");
            window.localStorage.removeItem(storageKey);
            window.location.reload();
          }}
          type="button"
          className="btn btn-primary"
        >
          {localization.removeFilter}
        </button>
      </div>
    </form>
  );
};

export default HsnFilter;
